// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__i9nBr","footer":"ModalFilter_footer__3Ya58"};